import axios from "@/axios"; 
const API_URL = process.env.VUE_APP_API_BASE_URL;

export function usePingApi() {
  async function checkPing(ip) {
    try {
      const response = await axios.get(`${API_URL}/png?ip_address=${ip}`);
      console.log('Ping API response:', response.data); // Log the actual response data
      return response.data; // Return the raw response data
    } catch (error) {
      console.error("Error retrieving ping data:", error);
      throw error;
    }
  }

  async function getPing() {
    try {
      const response = await axios.get(`${API_URL}/ipmonitor-data`);
      console.log('getPing response:', response);
      return response;
    } catch (error) {
      console.error("Error in getPing:", error);
      throw error;
    }
  }
  async function createServer(serverData) {
    try {
      const response = await axios.post(`${API_URL}/ipmonitor-data/`, serverData);
      console.log('getPing response:', response);
      return response;
    } catch (error) {
      console.error("Error in getPing:", error);
      throw error;
    }
  }
  
  async function updateServer(serverId, serverData) {
    console.log('Updating server:', serverData); // Debug log
    try {
      const response = await axios.put(`${API_URL}/ipmonitor-data/${serverId}/`, serverData);
      console.log('updateServer response:', response);
      return response;
    } catch (error) { 
      console.error("Error in updateServer:", error);
      throw error;
    }
  }
  async function deleteServer(serverId) {
    console.log('Deleting server:', serverId); // Debug log
    try {
      const response = await axios.delete(`${API_URL}/ipmonitor-data/${serverId}/`);
      console.log('deleteServer response:', response);
      return response;
    } catch (error) {     
      console.error("Error in deleteServer:", error);
      throw error;
    }
  }
  
  
  return {
    checkPing,
    getPing,
    createServer,
    updateServer,
    deleteServer,
  };
}